<template>
  <SysDialog
    v-model="dialog"
    largura="450"
    @click:primary="salvarDados()"
  >
    <template #titulo>
      {{ TITULO_DIALOG }}
    </template>

    <sys-data-table
      :headers="headers"
      :items="desserts"
      :height="alturaDaJanela - 600"
      :item-height="30"
      hide-default-footer
    >
      <template #item.data="{ item }">
        <v-menu
          :ref="`menu-${item.id_grupo_sep}`"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="item.data"
              readonly
              outlined
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="item.data_formatada"
            no-title
            scrollable
            @change="formatarData(item)"
            :min="DATA_ATUAL"
            :allowed-dates="disabilitarFeriados"
          />
      </v-menu>
      </template>
    </sys-data-table>
  </SysDialog>
</template>

<script>
import moment from 'moment';
import Responsividade from '@/helpers/ResponsiveHeight';
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import { getDatasDeFeriados, storeMudancaGrupo } from "@/api/drp";

export default {
  components: { SysDialog },
  mixins: [Responsividade],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    menu: false,
    dialog: false,
    headers: [
      { value: 'nome_grupo_separacao', text: 'Nome Grupo', style: { width: '270px'} },
      { value: 'data', text: 'Data' }
    ],
    desserts: [],
    datas_desabilitadas: []
  }),
  computed: {
    TITULO_DIALOG() {
      return 'Alterar data dos grupos ja existentes'
    },
    DATA_ATUAL() {
      return moment().toISOString();
    }
  },
  watch: {
    items(valor) {
      this.dialog = valor.length > 0;
      this.desserts = valor;
    },
    dialog(valor) {
      if (valor) this.buscarDatasDeFeriados();
    }
  },
  methods: {
    formatarData(item) {
      item.data = moment(item.data_formatada).format('DD/MM/YYYY');
    },
    buscarDatasDeFeriados() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getDatasDeFeriados()
          .then((dados) => {
            const datas = dados.map(m => moment(m.data_feriado, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            this.datas_desabilitadas = datas;
          })
          .catch(() => this.Helpers.logout())
      );
    },
    disabilitarFeriados(date) {
      return !this.datas_desabilitadas.includes(date);
    },
    salvarDados() {
      this.$store.dispatch(
        "loading/addRequisicao",
        storeMudancaGrupo(this.desserts)
          .then(() => this.fecharDialog())
          .catch(() => this.Helpers.logout())
      );
    },
    fecharDialog() {
      this.$emit('atualizar-lista-de-feriados');
      this.dialog = false;
    }
  }
}
</script>

<style>

</style>
